import call from "@/conn-global/api";

export default {
  // getDataApi: ({ commit }) => {
  //   call
  //     .get("https://api.coindesk.com/v1/bpi/currentprice.json")
  //     .then((res) => {
  //       if (res != undefined) {
  //         commit("addDataApi", res.data);
  //       }
  //     })
  //     .catch((err) => {
  //       alert(err);
  //     });
  // },
  postLogin: ({ commit }) => {
    let data = {
      country_code: "62",
      telp: "85159722546",
      password: "ilham",
    };
    call
      .post("/v1/auth/login", data)
      .then((res) => {
        alert(res);
        if (res != undefined) {
          commit("addLogin", res.data);
          alert(res.status);
        }
      })
      .catch((err) => {
        alert(err);
      });
  },
};
